const selectors = {
  container: '[data-quantity-selector]',
  error: '[data-quantity-error]',
};

const classes = {
  hide: 'hide',
};

const qtySelector = (decrementBtn, incrementBtn, input) => {
  if (!decrementBtn || !incrementBtn || !input) return;

  const container = input.closest(selectors.container);
  const outerContainer = container.parentNode;

  const inputMin = Number(input.getAttribute('min'));
  const inputMax = input.getAttribute('max') ? Number(input.getAttribute('max')) : null;

  const handleButtonsDisableState = (qty) => {
    decrementBtn.disabled = qty <= inputMin;
  };

  const handleQuantityLimitMessage = (qty) => {
    if (!inputMax) return;

    const quantityIsValid = inputMax && qty <= inputMax;
    const errorMessageElem = outerContainer?.querySelector(selectors.error);

    // Show quantity limit message (create if it doesn't exist)
    if (!quantityIsValid) {
      if (errorMessageElem) {
        errorMessageElem.classList.remove(classes.hide);
        return;
      }

      const errorMessageNewElem = document.createElement('p');
      errorMessageNewElem.classList.add('quantity-selector__error');
      errorMessageNewElem.setAttribute('data-quantity-error', '');
      errorMessageNewElem.textContent = window.theme?.strings?.quantityLimit.replace('{{ number }}', inputMax);

      outerContainer?.insertBefore(errorMessageNewElem, null);
      return;
    }

    // Hide quantity limit message
    errorMessageElem?.classList.add(classes.hide);
  };

  decrementBtn.addEventListener('click', () => {
    const newQty = Number(input.value) - 1;
    if (newQty <= 0) return;

    input.value = Number(newQty);

    handleButtonsDisableState(newQty);
    handleQuantityLimitMessage(newQty);
  });

  incrementBtn.addEventListener('click', () => {
    const newQty = Number(input.value) + 1;
    input.value = inputMax && newQty > inputMax ? inputMax : Number(newQty);

    handleButtonsDisableState(newQty);
    handleQuantityLimitMessage(newQty);
  });

  input.addEventListener('input', () => {
    const inputValue = Number(input.value);

    if (inputMax && inputValue > inputMax) {
      input.value = inputMax;
    }

    handleButtonsDisableState(inputValue);
    handleQuantityLimitMessage(inputValue);
  });
};

export default qtySelector;
